(() => {
  if (window.__epCommerceAnalyticsLoaded) return;
  window.__epCommerceAnalyticsLoaded = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-ep-commerce-action]')
      : null;

    if (!target) return;

    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;

    const payload = {
      action: target.dataset.epCommerceAction || 'open',
      placement: target.dataset.epCommercePlacement || '',
      productHandle: target.dataset.epProductHandle || '',
      collectionHandle: target.dataset.epCollectionHandle || '',
      destination: target.getAttribute('href') || '',
    };

    try {
      const result = publish('facipack:commercial_link_clicked', payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (error) {
      // Analytics must never interfere with navigation.
    }
  });
})();
